import styled from 'styled-components';

export const TopbarLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
  min-width: 0;

  img {
    display: block;
    width: 9rem;
    height: 3rem;
    object-fit: contain;
  }

  /* Mobile: up to 425px */
  @media (max-width: 427px) {
    img {
      width: 4rem;
      height: 2rem;
    }
  }

  /* Tablet: 768px to 1024px */
  @media (min-width: 768px) and (max-width: 1023px) {
    img {
      width: 5rem;
      height: 4rem;
    }
  }
`;